/** Default block-level highlight (navigation / reference click). */
export const DOC_HIGHLIGHT_CLASS = "doc-highlight";

/** Block-level highlight for sidebar hover when only block ids are known (blue tint; distinct from {@link DOC_HIGHLIGHT_CLASS}). */
export const REFERENCE_SIDEBAR_PREVIEW_BLOCK_CLASS =
  "doc-highlight-sidebar-preview";
